export default "__VITE_ASSET__HYkxCX19__"